<div class="layout-breadcrumb">
  <div class="breadcrumb">
    <div class="route-bar-breadcrumb">
      <ng-template ngFor let-item let-last="last" [ngForOf]="items">
        <li>
          <a [routerLink]="item.routerLink" *ngIf="item.routerLink">{{
            item.label
          }}</a>
          <ng-container *ngIf="!item.routerLink">{{ item.label }}</ng-container>
        </li>
        <li *ngIf="!last"><i class="pi pi-angle-right"></i></li>
      </ng-template>
    </div>
  </div>

  <div class="flex justify-content-end align-items-center ml-auto">
    <a
      *ngIf="docsUrl"
      [href]="docsUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button
        pButton
        type="button"
        class="floating-btn"
        title="Press for viewing the User Manual / Docs"
      >
        <img src="/assets/layout/images/user-manual.png" alt="User Manual" />
      </button>
    </a>
  </div>
</div>
